import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MtiComponent} from './mti.component';
import {MatIconModule} from '@angular/material/icon';
import {TdoControlsModule} from '../../../../tdo-controls/tdo-controls.module';
import {MatRadioModule} from '@angular/material/radio';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MtiTeethComponent } from './mti-teeth/mti-teeth.component';
import {DirectivesModule} from '../../../../directives/directives.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { MtiPriorExamToothDialogComponent } from './dialog/mti-prior-exam-tooth-dialog/mti-prior-exam-tooth-dialog.component';
import { MtiTeethDialogComponent } from './dialog/mti-teeth-dialog/mti-teeth-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    MtiComponent,
    MtiTeethComponent,
    MtiPriorExamToothDialogComponent,
    MtiTeethDialogComponent
  ],
  imports: [
    DirectivesModule,
    CommonModule,
    MatIconModule,
    TdoControlsModule,
    MatRadioModule,
    MatCheckboxModule,
    MatTooltipModule,
    DragDropModule,
    MatProgressSpinnerModule,
  ],
    exports: [
        MtiComponent,
        MtiTeethComponent
    ]
})
export class MtiModule { }
